module.exports = __webpack_public_path__ + "static/media/offline_synced.34cbd967.png";